import React from 'react';
import { BrowserRouter as Router, Routes, Route, Link, useLocation } from 'react-router-dom';
import { AuthProvider } from './AuthContext';
import Dashboard from './Dashboard';
import VersionControl from './VersionControl';
import './Dashboard.css';

function Navigation() {
  const location = useLocation();

  return (
    <nav className="app-navigation">
      <Link
        to="/"
        className={`nav-link ${location.pathname === '/' ? 'active' : ''}`}
      >
        Dashboard
      </Link>
      <Link
        to="/versions"
        className={`nav-link ${location.pathname === '/versions' ? 'active' : ''}`}
      >
        Version Control
      </Link>
    </nav>
  );
}

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="App">
          <Navigation />
          <Routes>
            <Route path="/" element={<Dashboard />} />
            <Route path="/versions" element={<VersionControl />} />
          </Routes>
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;